// extracted by mini-css-extract-plugin
export var buttons = "Buttons-module--buttons--2_Obw";
export var end = "Buttons-module--end--2WrGA";